<template>
  <div class="login-container">
    <div class="homepage-hero-module" :style="note">
      <div class="login-header">
        <p class="word-v-middle"><span>{{ systemName }}</span></p>
      </div>
      <el-form class="login-form" :model="loginForm" :rules="rules" ref="loginForm" autoComplete="on" label-position="left">
        <div class="ms-login">
          <div class="login-body">
            <el-form-item prop="username">
              <el-input name="username" size="medium" v-model="loginForm.username" autoComplete="on" autofocus="autofocus" placeholder="用户名">
                <div class="login-username" slot="prepend"></div>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input name="password" type="password" size="medium" v-model="loginForm.password" placeholder="口令" @keyup.enter.native="doLogin">
                <template slot="prepend"><div class="login-password"></div></template>
              </el-input>
            </el-form-item>
            <el-button type="primary" :loading="showLoading" @click.native.prevent="doLogin">登录</el-button>
          </div>
        </div>
        <div class="zhushi" style="text-align: center">
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
  import { getToken } from '@/api/admin/auth'
  import { getAuthorizedRouter } from '@/api/admin/router'
  import { mapGetters } from 'vuex'
  import { getSystemInfoById } from '@/api/web/systeminfo'

  export default {
    data() {
      return {
        systemName:'',
        systemNumber1:'',
        systemVersion:'',
        note: {
          backgroundImage: "url(" + require("../../assets/images/login/login_bg1.jpg") + ") ",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        },

        vedioCanPlay: false,
        fixStyle: '',
        displayLoading: false,
        loginForm: {
          username: '',
          password: ''
        },
        rules: {
          username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          password: [{ required: true, message: '请输入口令', trigger: 'blur' }]
        }
      };
    },
    computed: {
      ...mapGetters(['showLoading'])
    },
    created: function() {
      this.getSystemInfo()
    },
    methods: {
      getSystemInfo() {
        getSystemInfoById(1)
          .then(response => {
            this.systemName = response.data.data.detail.portalName;
            this.systemNumber1 = response.data.data.detail.recordNumber1;
            this.systemVersion = response.data.data.detail.systemVersion;
            this.loading = true
          })
          .catch(error => {
            this.outputError(error)
          })
      },
      canplay() {
        cons
        this.vedioCanPlay = true
      },
      doLogin() {
        this.$refs['loginForm'].validate(valid => {
          if (valid) {
            this.$store.dispatch('setLoading', true)
            getToken(this.loginForm)
              .then(response => {
                if(response.data.result==0){
                  sessionStorage.setItem('currentUser', JSON.stringify({
                    id: response.data.data.userId,
                    name: response.data.data.userName,
                    logoUrl:response.data.data.logoUrl
                  }))
                  sessionStorage.setItem('goupCode', response.data.data.groupCode)
                  sessionStorage.setItem('token', response.data.data.token)
                  sessionStorage.setItem('routers', JSON.stringify(response.data.data.routers))

                  // 初始化首页路由
                  this.initIndexRouter()

                  let redirect = decodeURIComponent(
                    this.$route.query.redirect || "/"
                  )
                  this.$router.push(redirect);
                  this.$store.dispatch('setLoading', false)
                }else{
                  this.$message({
                    showClose: true,
                    message: response.data.msg,
                    type: 'error'
                  })
                }

              })
              .catch(error => {
                this.$store.dispatch('setLoading', false)
                this.$message({
                  showClose: true,
                  message: error,
                  type: 'error'
                })
              })
          }
        })
      },
      initIndexRouter() {
        let indexRouter = {
          path: '/',
          name: "首页",
          redirect: 'home-content',
          component: resolve => require(['@/views/homeTab/index'], resolve),
          children: [...this.generateChildRouters()]
        }
        this.$router.addRoutes([indexRouter])
      },
      generateChildRouters() {
        if (!sessionStorage.routers) {
          return []
        }

        let routers = JSON.parse(sessionStorage.routers)
        let childRouters = []
        for(let router of routers) {
          if(router.code != null & router.code != "") {
            let routerProps = JSON.parse(router.properties)
            let childRouter = {
              path: router.url,
              name: router.name,
              component: resolve => require(['@/views/' + router.code ], resolve),
              meta: { routerId: router.id, requiresAuth: routerProps.meta.requiresAuth, nameFullPath: routerProps.nameFullPath }
            }
            childRouters.push(childRouter)
          }
        }
        let childRouter = {//把首页子路径加入进来
          path: "home-content",
          name: "首页",
          component: resolve => require(['@/components/home/home-content'], resolve),
          meta: { routerId: 0, requiresAuth:false, nameFullPath:"" }
        }
        childRouters.push(childRouter)
        return childRouters
      }
    },
    mounted: function() {
      window.onresize = () => {
        const windowWidth = document.body.clientWidth
        const windowHeight = document.body.clientHeight
        const windowAspectRatio = windowHeight / windowWidth
        let videoWidth
        let videoHeight
        if (windowAspectRatio < 0.5625) {
          videoWidth = windowWidth
          videoHeight = videoWidth * 0.5625
          this.fixStyle = {
            height: windowWidth * 0.5625 + 'px',
            width: windowWidth + 'px',
            'margin-bottom': (windowHeight - videoHeight) / 2 + 'px',
            'margin-left': 'initial'
          }
        } else {
          videoHeight = windowHeight
          videoWidth = videoHeight / 0.5625
          this.fixStyle = {
            height: windowHeight + 'px',
            width: windowHeight / 0.5625 + 'px',
            'margin-left': (windowWidth - videoWidth) / 2 + 'px',
            'margin-bottom': 'initial'
          }
        }
      }
      window.onresize()
    }
  }
</script>


<style rel="stylesheet/scss" lang="scss" scoped>

  .ms-login{
    position: absolute;
    left:50%;
    top:100%;
    width:350px;
    margin:-190px 0 0 -175px;
    /*padding: 20px 20px 40px 20px;*/

    border-radius: 5px;
    background: rgba(255,255,255, 0.4);
    overflow: hidden;
  }

  .word-v-middle{
    margin-bottom: 0;
    font-size: 50px;
    min-height: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 10px;
    margin-top: 5px;
    color: 	#fff;/*87878a   050505   fff*/
    white-space: normal;}
  .word-v-middle span{
    text-align: left;
    font-size: 50px;
    padding-bottom: 1px;
    padding-top: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .homepage-hero-module,
  .video-container {
    position: relative;
    height: 100vh;
    overflow: hidden;
  }
  .video-container .poster img,
  .video-container video {
    z-index: 0;
    position: absolute;
  }
  .video-container .filter {
    z-index: 1;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
  }

  .login-container {
    background-color: black;
    .el-input {
      width: 100%;
    }
    .el-button {
      width: 100%;
    }
    .login-form {
      position: absolute;
      left: 0;
      right: 0;
      width: 300px;
      height: 200px;
      margin: 120px auto;
      margin-bottom: 20px;
      margin-top: 130px;
      /* border: 1px solid #e0dedb;*/
      border-radius: 4px;
      -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
    }
    .login-header {
      padding: 40px 35px;
      /*border-bottom: 1px solid #d0cdc7;*/
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      /*background-color: #f6f5f4;*/
      .login-title {
        font-size: 40px;
      }
    }
    .login-body {

      padding: 30px 30px 40px 30px;
      text-align: center;
      .profile-img {
        width: 96px;
        height: 96px;
        margin: 0 auto 10px;
        display: block;
      }
      .login-username {
        width: 20px;
        height: 20px;
        margin: 0px -10px;
        background-image: url("../../assets/images/user.png");
      }
      .login-password {
        width: 20px;
        height: 20px;
        margin: 0px -10px;
        background-image: url("../../assets/images/lock.png");
      }
    }
  }
  .zhushi{
    margin-top: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue